// @ngInject
function ArticleChangeVariantDetailDialogService($uibModal, ProductsApiService) {

    return {
        showDialog: showDialog
    };

    function showDialog(article) {

        var modalDefaults = {
            backdrop: 'static',
            keyboard: false,
            controller: 'ArticleChangeVariantDetailDialogController as vm',
            templateUrl: 'main/product/articles/articleChangeVariantDetailDialog/articleChangeVariantDetailDialog.tpl.html',
            size: 'md',
            resolve: {
                articleChangeVariantDetailObject: function () {
                    return ProductsApiService.getArticleChangeVariantDetailObject(article.id);
                }
            }
        };

        return $uibModal.open(modalDefaults).result;
    }
}


// @ngInject
function ArticleChangeVariantDetailDialogController($scope, $uibModalInstance, $timeout, articleChangeVariantDetailObject, ProductsApiService, loadSpinnerService, ResourcesService, ToasterService, $translate) {
    var vm = this;

    vm.changeVariantDetailObject = articleChangeVariantDetailObject;

    _.forEach(vm.changeVariantDetailObject.articleVariantDetailObjects, function(dobj){
        dobj.newVariantDetailName = ""
    })

    vm.anyError = false;
    vm.isValidating = false;

    vm.closeModal = closeModal;
    vm.saveNewVariantDetails = saveNewVariantDetails;
    vm.anyChanges = anyChanges;
    vm.getColourText = getColourText;

    vm.validate = validate;

    activate();
    
    function activate() {}

    function validate(){
        _.forEach(vm.changeVariantDetailObject.articleVariantDetailObjects, function(obj){obj.hasError = false;});
        vm.anyError = false;
        vm.isValidating = true;

        _.forEach(vm.changeVariantDetailObject.articleVariantDetailObjects.filter(x => x.newVariantDetailObject), function(withNewObj){
            _.forEach(vm.changeVariantDetailObject.articleVariantDetailObjects, function(obj){
                if(obj.variantDetailObject.id !== withNewObj.variantDetailObject.id){
                    if(obj.newVariantDetailObject){
                        if(obj.newVariantDetailObject.id === withNewObj.newVariantDetailObject.id){
                            if(hasIntersectingColours(obj.coloursOnArticleVariant, withNewObj.coloursOnArticleVariant)){
                                vm.anyError = true;
                                obj.hasError = true;
                                withNewObj.hasError = true;
                            }
                        }
                    }
                    else if(obj.variantDetailObject.id === withNewObj.newVariantDetailObject.id){
                        if(hasIntersectingColours(obj.coloursOnArticleVariant, withNewObj.coloursOnArticleVariant)){
                            vm.anyError = true;
                            obj.hasError = true;
                            withNewObj.hasError = true;
                        }
                    }
                }
            });
        });
        
        vm.isValidating = false;
    }

    function hasIntersectingColours(aColours, bColours){
        var intersecting = false;

        _.forEach(aColours, function(a){
            var length = bColours.filter(x => x.id === a.id).length;
            if(length > 0){
                intersecting = true;
            }
        });

        return intersecting;
    }
    function saveNewVariantDetails(){
        var requestObject = {
            articleId: vm.changeVariantDetailObject.productId,
            articleVariantDetailObjectsChanged: []
        }

        _.forEach(vm.changeVariantDetailObject.articleVariantDetailObjects, function(obj){
            if(obj.newVariantDetailObject) {
                requestObject.articleVariantDetailObjectsChanged.push({
                    articleVariantIds: obj.articleVariantIds,
                    variantDetailObject: obj.newVariantDetailObject
                });
            }
        });

        loadSpinnerService.start("mainSpinner");
        ProductsApiService.changeArticleVariantDetail(requestObject).then(function (response){
            var message = `${$translate.instant('common.success')}`
            ToasterService.showSuccess(message, $translate.instant('common.success'));
            closeModal(true);
        }, function (error){
            ToasterService.showError(error.message, $translate.instant('common.error'));
        }).finally(function() {
            loadSpinnerService.stop("mainSpinner");
        });
    }

    function anyChanges(){
        var obj = vm.changeVariantDetailObject.articleVariantDetailObjects.filter(x => x.newVariantDetailObject)

        return obj.length > 0
    }

    function getColourText(colours, cutoff){
        var returnString = '';
        _.forEach(colours, function(colour){
            if(returnString !== '')
                returnString += ', '

            returnString += colour.name
        });

        if(returnString.length > 35 && cutoff)
            return returnString.substring(0, 35) + '...';
        return returnString;
    }

    function closeModal(refresh) {
        $uibModalInstance.close(refresh);
    }
}

angular
    .module('product.articles.articleChangeVariantDetailDialog', [])
    .service('ArticleChangeVariantDetailDialogService', ArticleChangeVariantDetailDialogService)
    .controller('ArticleChangeVariantDetailDialogController', ArticleChangeVariantDetailDialogController);